import { Shield } from "lucide-react";
import { useProtectedRoutes } from "@/hooks/useProtectedRoutes";

interface MainMenuItemPinProps {
  path: string;
}

export function MainMenuItemPin({ path }: MainMenuItemPinProps) {
  const { data: protectedRoutes = [] } = useProtectedRoutes();
  
  // Check if this route is protected
  const basePath = path.split('?')[0].split('#')[0];
  const isProtected = protectedRoutes.some((protectedRoute: string) => {
    // Handle dynamic routes like /meetings/:id
    const pattern = protectedRoute.replace(/:[^/]+/g, '[^/]+');
    const regex = new RegExp(`^${pattern}$`);
    const exactMatch = regex.test(basePath);
    const prefixMatch = basePath.startsWith(protectedRoute);
    return exactMatch || prefixMatch;
  });

  if (!isProtected) return null;

  return (
    <span title="PIN Protected">
      <Shield className="h-3 w-3 text-primary" />
    </span>
  );
}
